import React from "react";
import msufcuLogo from "assets/images/partners/msufcu.svg";
import msufcuLogoReverse from "assets/images/partners/msufcu-reverse.svg";
import cusgLogo from "assets/images/partners/cusg.svg";
import cusgLogoReverse from "assets/images/partners/cusg-reverse.svg";
import ndrLogo from "assets/images/partners/ndr.svg";
import ndrLogoReverse from "assets/images/partners/ndr-reverse.svg";
import cscLogo from "assets/images/partners/csc.png";
import cscLogoReverse from "assets/images/partners/csc-reverse.png";
import { PartnerSlug, ProductName } from "types/general";
import { Partner } from "./types";
import MsufcuBannerMessage from "./MsufcuBannerMessage";
import CusgBannerMessage from "./CusgBannerMessage";
import NdrBannerMessage from "./NdrBannerMessage";
import CscBannerMessage from "./CscBannerMessage";

export const PARTNERS: {
  [key in PartnerSlug]: Partner;
} = {
  msufcu: {
    slug: "msufcu",
    name: "MSUFCU",
    enableProbationaryLimit: false,
    incomeTaxRefundAdvanceAllowed: true,
    logo: { color: msufcuLogo, reverse: msufcuLogoReverse },
    banner: {
      message: <MsufcuBannerMessage />,
      theme: {
        color: "#FFFFFF",
        background: "#004F38",
      },
    },
    faqs: {
      identityVerification: [
        {
          title: "Why does Reset need this information?",
          body: "The Reset card application requires a separate identity verification than the one for opening an MSUFCU account.",
        },
      ],
    },
  },
  cusg: {
    slug: "cusg",
    name: "CUSG",
    enableProbationaryLimit: false,
    logo: { color: cusgLogo, reverse: cusgLogoReverse },
    banner: {
      message: <CusgBannerMessage />,
      theme: {
        color: "#FFFFFF",
        background: "#004d98",
      },
    },
  },
  "national-debt-relief": {
    slug: "national-debt-relief",
    name: "National Debt Relief",
    enableProbationaryLimit: false,
    logo: { color: ndrLogo, reverse: ndrLogoReverse },
    banner: {
      message: <NdrBannerMessage />,
      theme: {
        color: "#FFFFFF",
        background: "#1f2147",
      },
    },
  },
  csc: {
    slug: "csc",
    name: "CSC",
    enableProbationaryLimit: false,
    logo: { color: cscLogo, reverse: cscLogoReverse },
    banner: {
      message: <CscBannerMessage />,
      theme: {
        color: "#FFFFFF",
        background: "#142A65",
      },
    },
    homepageUrlByProduct: {
      [ProductName.earnedWageAccess]: "/csc",
      [ProductName.taxRefundAdvance]: "/csc/tax",
    },
  },
};
